<div class="px-5 pt-7 pb-10">
  <app-unauth-header></app-unauth-header>
  <div class="w-full">
    <div
      class="w-full rounded-2xl bg-linear-(--my-gradient1) border-[#D9D9D9] shadow-(--my-shadow) pt-6 px-2 lg:px-5 mb-4 mb-md-0">
      <p class="text-white font-bold text-xl md:text-2xl lg:text-4xl xl:text-[45px] capitalize text-center mb-1">Sign Up
      </p>
      <div class="bg-white mt-6 lg:mt-6 px-4 py-5 w-full rounded-lg">
        <form [formGroup]="signUpForm" (ngSubmit)="onSubmit()">
          <div class="grid xs:grid-cols-1 sm:grid-cols-6 gap-3 space-y-2">

            <div class="xs:col-span-1 sm:col-span-3 md:col-span-2">
              <div class="flex items-start gap-2">
                <div class="relative grow">
                  <input formControlName="gstnumber" type="text" id="gstnumber"
                    class="block px-2.5 pb-3 pt-3 w-full text-sm lg:text-base text-555 font-normal bg-transparent rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
                    placeholder=" " />
                  <label for="gstnumber"
                    class="absolute text-sm lg:text-base text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">GST
                    No.</label>
                </div>

                <button type="button" (click)="patchData()"
                  class="block cursor-pointer px-5 py-2.5 text-base lg:text-lg font-bold text-white bg-c19725 border-1 border-c19725 hover:bg-[#fdffc6] hover:text-c19725 hover:shadow-lg focus:ring-0 focus:outline-none rounded-md"
                  [disabled]="isGstLoading">
                  <span *ngIf="!isGstLoading">Fetch</span>
                  <i *ngIf="isGstLoading" class="fas fa-spinner fa-spin"></i>
                </button>
              </div>

              <div
                *ngIf="signUpForm.controls['gstnumber'].invalid && (signUpForm.controls['gstnumber'].touched || signUpForm.controls['gstnumber'].dirty)">
                <span class="text-danger" *ngIf="signUpForm.controls['gstnumber'].errors?.['required']"> *GST Number is
                  required</span>
                <span class="text-danger"
                  *ngIf="signUpForm.controls['gstnumber'].errors?.['minlength'] || signUpForm.controls['gstnumber'].errors?.['maxlength']">*GST
                  Number must be exactly 15 characters</span>
                <span class="text-danger" *ngIf="signUpForm.controls['gstnumber'].errors?.['pattern']"> *Invalid GST
                  Number format</span>
              </div>
            </div>


            <div class="xs:col-span-1 sm:col-span-3 md:col-span-2">
              <div class="relative">
                <input formControlName="name" id="name"
                  class="block px-2.5 pb-3 pt-3 w-full text-sm lg:text-base text-555 font-normal bg-transparent rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
                  placeholder=" ">
                <label for="name"
                  class="absolute text-sm lg:text-base text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Name</label>
              </div>
              <div
                *ngIf="signUpForm.controls['name'].invalid && (signUpForm.controls['name'].touched || signUpForm.controls['name'].dirty)">
                <span class="text-danger" *ngIf="signUpForm.controls['name'].errors?.['required']">*Name is
                  required</span>
                <span class="text-danger" *ngIf="signUpForm.controls['name'].errors?.['minlength']">*Name must be at
                  least 3 characters long</span>
                <span class="text-danger" *ngIf="signUpForm.controls['name'].errors?.['maxlength']">*Name cannot exceed
                  50 characters</span>
                <span class="text-danger" *ngIf="signUpForm.controls['name'].errors?.['pattern']">*Name can only contain
                  alphabets and spaces</span>
              </div>
            </div>

            <div class="xs:col-span-1 sm:col-span-3 md:col-span-2">
              <div class="relative">
                <input formControlName="mobilenumber" id="mobilenumber"
                  class="block px-2.5 pb-3 pt-3 w-full text-sm lg:text-base text-555 font-normal bg-transparent rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
                  placeholder=" " type="text" maxlength="10" minlength="10" pattern="^[0-9]{10}$" inputmode="numeric"
                  required />
                <label for="mobilenumber"
                  class="absolute text-sm lg:text-base text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Phone
                  No.</label>
              </div>

              <div *ngIf="signUpForm.controls['mobilenumber'].invalid &&
                (signUpForm.controls['mobilenumber'].touched || signUpForm.controls['mobilenumber'].dirty)">
                <span class="text-danger" *ngIf="signUpForm.controls['mobilenumber'].errors?.['required']">*Mobile
                  number is required</span>
                <span class="text-danger" *ngIf="signUpForm.controls['mobilenumber'].errors?.['minlength']">*Mobile
                  number must be at least 10 digits</span>
                <span class="text-danger" *ngIf="signUpForm.controls['mobilenumber'].errors?.['maxlength']">*Mobile
                  number cannot exceed 10 digits</span>
                <span class="text-danger" *ngIf="signUpForm.controls['mobilenumber'].errors?.['pattern']">*Please enter
                  a valid 10-digit mobile number</span>
              </div>
            </div>

            <div class="xs:col-span-1  sm:col-span-3 md:col-span-2">
              <div class="relative">
                <input formControlName="email" id="email"
                  class="block px-2.5 pb-3 pt-3 w-full text-sm lg:text-base text-555 font-normal bg-transparent rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
                  placeholder=" " type="email" required />
                <label for="email"
                  class="absolute text-sm lg:text-base text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Email
                  ID</label>
              </div>
              <div
                *ngIf="signUpForm.controls['email'].invalid && (signUpForm.controls['email'].touched || signUpForm.controls['email'].dirty)">
                <span class="text-danger" *ngIf="signUpForm.controls['email'].errors?.['required']">*Email is
                  required</span>
                <span class="text-danger" *ngIf="signUpForm.controls['email'].errors?.['pattern']">*Please enter a valid
                  email address</span>
              </div>
            </div>


            <div class="xs:col-span-1 sm:col-span-4">
              <div class="relative">
                <input formControlName="address" type="text" id="address"
                  class="block px-2.5 pb-3 pt-3 w-full text-sm lg:text-base text-555 font-normal bg-transparent rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
                  placeholder=" " />
                <label for="address"
                  class="absolute text-sm lg:text-base text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Address</label>
              </div>
              <div
                *ngIf="signUpForm.controls['address'].invalid && (signUpForm.controls['address'].touched || signUpForm.controls['address'].dirty)">
                <span class="text-danger" *ngIf="signUpForm.controls['address'].errors?.['required']">*address is
                  required</span>
                <span class="text-danger" *ngIf="signUpForm.controls['address'].errors?.['minlength']">*Address must be
                  at least 5 characters long</span>
                <span class="text-danger" *ngIf="signUpForm.controls['address'].errors?.['maxlength']">*Address cannot
                  exceed 150 characters</span>
              </div>
            </div>

            <div class="col-span-1 sm:col-span-2 md:col-span-1">
              <div class="relative">
                <select formControlName="country" (change)="onCountryChange()"
                  class="block pl-2.5 pr-6 pb-3 pt-3 w-full text-sm lg:text-base capitalize text-555 font-normal bg-transparent rounded-md border-1 border-dcdcdc appearance-none !bg-none focus:outline-none focus:ring-0 focus:border-c19725 peer">
                  <option value="" disabled selected class="text-sm">Select Country</option>
                  <option *ngFor="let country of countries" [value]="country.id">{{ country.name }}</option>
                </select>
                <div class="absolute inset-y-0 right-2 flex items-center pointer-events-none">
                  <svg width="14" height="7" viewBox="0 0 14 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.00004 7.00016L0.333374 0.333496H13.6667L7.00004 7.00016Z" fill="#C19725" />
                  </svg>
                </div>
                <label for="country"
                  class="absolute text-sm lg:text-base text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Country</label>
              </div>
              <div *ngIf="signUpForm.controls['country'].invalid &&
              (signUpForm.controls['country'].touched || signUpForm.controls['country'].dirty)">
                <span class="text-danger" *ngIf="signUpForm.controls['country'].errors?.['required']">*country is
                  required</span>
              </div>
            </div>


            <div class="xs:col-span-1 sm:col-span-2 md:col-span-1">
              <div class="relative">
                <input formControlName="pincode" type="text" id="pincode"
                  class="block tracking-[10px] sm:tracking-[5px] lg:tracking-[10px] px-2.5 pb-3 pt-3 w-full text-sm lg:text-base text-555 font-normal bg-transparent rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
                  placeholder=" " />
                <label for="pincode"
                  class="absolute text-sm lg:text-base text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Pincode</label>
              </div>
              <div *ngIf="signUpForm.controls['pincode'].invalid &&
              (signUpForm.controls['pincode'].touched || signUpForm.controls['pincode'].dirty)">
                <span class="text-danger" *ngIf="signUpForm.controls['pincode'].errors?.['required']">*pincode is
                  required</span>
                <span class="text-danger" *ngIf="signUpForm.controls['pincode'].errors?.['pattern']">*Pincode must be
                  exactly 6 digits (numbers only)</span>
              </div>
            </div>

            <div class="xs:col-span-1 sm:col-span-2">
              <div class="relative">
                <input formControlName="jewelleryappcode" type="text" id="jewelleryappcode"
                  class="block px-2.5 pb-3 pt-3 w-full text-sm lg:text-base text-555 font-normal bg-transparent rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
                  placeholder=" " />
                <label for="jewelleryappcode"
                  class="absolute text-sm lg:text-base text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Jewellersapp
                  Code</label>
              </div>
              <div *ngIf="signUpForm.controls['jewelleryappcode'].invalid &&
              (signUpForm.controls['jewelleryappcode'].touched || signUpForm.controls['jewelleryappcode'].dirty)">
                <span class="text-danger"
                  *ngIf="signUpForm.controls['jewelleryappcode'].errors?.['required']">*jewelleryappcode is
                  required</span>
              </div>
            </div>

            <div class="xs:col-span-1 sm:col-span-2">
              <div class="relative">
                <input formControlName="billingname" type="text" id="billingname"
                  class="block px-2.5 pb-3 pt-3 w-full text-sm lg:text-base text-555 font-normal bg-transparent rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
                  placeholder=" " />
                <label for="billingname"
                  class="absolute text-sm lg:text-base text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Billing
                  Name</label>
              </div>
              <div *ngIf="signUpForm.controls['billingname'].invalid &&
              (signUpForm.controls['billingname'].touched || signUpForm.controls['billingname'].dirty)">
                <span class="text-danger" *ngIf="signUpForm.controls['billingname'].errors?.['required']">*Billing Name
                  is required</span>
                <span class="text-danger" *ngIf="signUpForm.controls['billingname'].errors?.['pattern']">*Billing Name
                  must be 3-50 characters and contain only letters and spaces </span>
              </div>
            </div>

            <div class="xs:col-span-1 sm:col-span-2 md:col-span-1">
              <div class="relative">
                <select formControlName="state" id="state" (change)="onStateChange()"
                  class="block pl-2.5 pr-6 pb-3 pt-3 w-full text-sm lg:text-base capitalize text-555 font-normal bg-transparent rounded-md border-1 border-dcdcdc appearance-none !bg-none focus:outline-none focus:ring-0 focus:border-c19725 peer">
                  <option value="" disabled selected class="text-sm">Select state</option>
                  <option *ngFor="let state of states" [value]="state.id">{{ state.name }}</option>
                </select>
                <div class="absolute inset-y-0 right-2 flex items-center pointer-events-none">
                  <svg width="14" height="7" viewBox="0 0 14 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.00004 7.00016L0.333374 0.333496H13.6667L7.00004 7.00016Z" fill="#C19725" />
                  </svg>
                </div>
                <label for="state"
                  class="absolute text-sm lg:text-base text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">State</label>
              </div>
              <div *ngIf="signUpForm.controls['state'].invalid &&
                (signUpForm.controls['state'].touched || signUpForm.controls['state'].dirty)">
                <span class="text-danger" *ngIf="signUpForm.controls['state'].errors?.['required']">*state is
                  required</span>
              </div>
            </div>

            <div class="xs:col-span-1 sm:col-span-2 md:col-span-1">
              <div class="relative">
                <select formControlName="city"
                  class="block pl-2.5 pr-6 pb-3 pt-3 w-full text-sm lg:text-base capitalize text-555 font-normal bg-transparent rounded-md border-1 border-dcdcdc appearance-none !bg-none focus:outline-none focus:ring-0 focus:border-c19725 peer">
                  <option value="" disabled selected class="text-sm">Select City</option>
                  <option *ngFor="let city of cities " [value]="city.id">
                    {{ city.name}}
                  </option>
                </select>
                <div class="absolute inset-y-0 right-2 flex items-center pointer-events-none">
                  <svg width="14" height="7" viewBox="0 0 14 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.00004 7.00016L0.333374 0.333496H13.6667L7.00004 7.00016Z" fill="#C19725" />
                  </svg>
                </div>
                <label for="city"
                  class="absolute text-sm lg:text-base text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">City</label>
              </div>
              <div *ngIf="signUpForm.controls['city'].invalid &&
                (signUpForm.controls['city'].touched || signUpForm.controls['city'].dirty)">
                <span class="text-danger" *ngIf="signUpForm.controls['city'].errors?.['required']">*city is
                  required</span>
              </div>
            </div>

            <div class="xs:col-span-1 sm:col-span-2">
              <div class="relative">
                <input formControlName="softwarepackages" type="text" id="softwarepackages"
                  class="block px-2.5 pb-3 pt-3 w-full text-sm lg:text-base text-555 font-normal bg-transparent rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
                  placeholder=" " />
                <label for="softwarepackages"
                  class="absolute text-sm lg:text-base text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Software
                  Packages</label>
              </div>
              <div *ngIf="signUpForm.controls['softwarepackages'].invalid &&
              (signUpForm.controls['softwarepackages'].touched || signUpForm.controls['softwarepackages'].dirty)">
                <span class="text-danger" *ngIf="signUpForm.controls['softwarepackages'].errors?.['required']">*Software
                  package is required</span>
              </div>
            </div>

            <div class="xs:col-span-1 sm:col-span-2">
              <div class="relative">
                <input formControlName="staffcode" type="text" id="staffcode"
                  class="block px-2.5 pb-3 pt-3 w-full text-sm lg:text-base text-555 font-normal bg-transparent rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
                  placeholder=" " />
                <label for="staffcode"
                  class="absolute text-sm lg:text-base text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Staff
                  Code</label>
              </div>
              <div *ngIf="signUpForm.controls['staffcode'].invalid &&
                (signUpForm.controls['staffcode'].touched || signUpForm.controls['staffcode'].dirty)">
                <span class="text-danger" *ngIf="signUpForm.controls['staffcode'].errors?.['required']">*staffcode is
                  required</span>
                <span class="text-danger" *ngIf="signUpForm.controls['staffcode'].errors?.['minlength']">*Staff Code
                  must be at least 3 characters</span>
                <span class="text-danger" *ngIf="signUpForm.controls['staffcode'].errors?.['maxlength']">*Staff Code
                  cannot exceed 10 characters</span>
                <span class="text-danger" *ngIf="signUpForm.controls['staffcode'].errors?.['pattern']">*Only letters and
                  numbers are allowed</span>
              </div>
            </div>

            <div class="xs:col-span-1 sm:col-span-2">
              <div class="relative">
                <svg (click)="showPassword = !showPassword"
                  class="absolute right-[10px] top-[16px] size-4 lg:size-5 cursor-pointer"
                  xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="#C19725" *ngIf="!showPassword">
                  <path
                    d="m644-428-58-58q9-47-27-88t-93-32l-58-58q17-8 34.5-12t37.5-4q75 0 127.5 52.5T660-500q0 20-4 37.5T644-428Zm128 126-58-56q38-29 67.5-63.5T832-500q-50-101-143.5-160.5T480-720q-29 0-57 4t-55 12l-62-62q41-17 84-25.5t90-8.5q151 0 269 83.5T920-500q-23 59-60.5 109.5T772-302Zm20 246L624-222q-35 11-70.5 16.5T480-200q-151 0-269-83.5T40-500q21-53 53-98.5t73-81.5L56-792l56-56 736 736-56 56ZM222-624q-29 26-53 57t-41 67q50 101 143.5 160.5T480-280q20 0 39-2.5t39-5.5l-36-38q-11 3-21 4.5t-21 1.5q-75 0-127.5-52.5T300-500q0-11 1.5-21t4.5-21l-84-82Zm319 93Zm-151 75Z" />
                </svg>

                <svg (click)="showPassword = !showPassword"
                  class="absolute right-[10px] top-[16px] size-4 lg:size-5 cursor-pointer z-10"
                  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#C19725" *ngIf="showPassword">
                  <!-- Eye ON Icon -->
                  <path
                    d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5C21.27 7.61 17 4.5 12 4.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z" />
                  <circle cx="12" cy="12" r="2.5" />
                </svg>

                <input [type]="showPassword ? 'text' : 'password'" formControlName="password" type="password"
                  id="password"
                  class="block px-2.5 pb-3 pt-3 w-full text-sm lg:text-base text-555 font-normal bg-transparent rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
                  placeholder=" " />
                <label for="password"
                  class="absolute text-sm lg:text-base text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Password
                </label>
              </div>
              <div *ngIf="signUpForm.controls['password'].invalid &&
              (signUpForm.controls['password'].touched || signUpForm.controls['password'].dirty)">
                <span class="text-danger" *ngIf="signUpForm.controls['password'].errors?.['required']">*Password is
                  required</span>
                <span class="text-danger" *ngIf="signUpForm.controls['password'].errors?.['minlength']">*Password must
                  be at least 8 characters</span>
              </div>
            </div>

            <div class="xs:col-span-1 sm:col-span-2">
              <div class="relative">
                <input formControlName="user_loginid" type="text" id="user_loginid"
                  class="block px-2.5 pb-3 pt-3 w-full text-sm lg:text-base text-555 font-normal bg-transparent rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
                  placeholder=" " />
                <label for="user_loginid"
                  class="absolute text-sm lg:text-base text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">User
                  Id
                </label>
              </div>
              <div *ngIf="signUpForm.controls['user_loginid'].invalid &&
              (signUpForm.controls['user_loginid'].touched || signUpForm.controls['user_loginid'].dirty)">
                <span class="text-danger" *ngIf="signUpForm.controls['user_loginid'].errors?.['required']">*userid is
                  required</span>
              </div>
            </div>

            <div class="xs:col-span-1 sm:col-span-2">
              <div class="relative flex">
                <div
                  class="w-1/2 h-full bg-[#fff7e6] rounded-l-md flex items-center justify-between pl-3 text-base font-semibold text-[#c19725] select-none border-r border-dcdcdc">
                  <span class="tracking-widest text-2xl font-bold">{{ generatedCaptcha }}</span>
                  <button type="button" (click)="refreshCaptcha()"
                    class="block cursor-pointer px-3 py-2.5 text-base lg:text-lg font-bold text-white bg-c19725 border-1 border-c19725 hover:bg-[#fdffc6] hover:text-c19725 hover:shadow-lg focus:ring-0 focus:outline-none rounded-l-md">
                    <i *ngIf="!isCaptchaLoading; else loadingCaptcha" class="fas fa-sync-alt"></i>
                    <ng-template #loadingCaptcha>
                      <i class="fas fa-spinner fa-spin"></i> <!-- Spinner Icon for Loader -->
                    </ng-template>
                  </button>
                </div>
                <div class="w-1/2">
                  <input formControlName="Captcha" type="text" id="Captcha" [(ngModel)]="userCaptcha"
                    class="block pb-3 pt-3 px-2.5 w-full text-sm lg:text-base text-555 font-normal bg-transparent rounded-r-md border border-dcdcdc border-l-0 focus:outline-none focus:ring-0 focus:border-c19725 peer"
                    placeholder="Enter Captcha" />
                </div>
              </div>


             <div *ngIf="signUpForm.controls['Captcha'].invalid &&
                (signUpForm.controls['Captcha'].touched || signUpForm.controls['Captcha'].dirty)">
                <span class="text-red-500 text-sm font-medium"
        *ngIf="signUpForm.controls['Captcha'].errors?.['required']">
    *Captcha is required
  </span>
  <span class="text-red-500 text-sm font-medium"
        *ngIf="signUpForm.controls['Captcha'].errors?.['invalidCaptcha']">
    *Enter a valid captcha code
  </span>
              </div>
            </div>


            <div class="xs:col-span-1 sm:col-span-6 md:col-span-4">
              <div class="flex items-center h-full">
                <mat-checkbox formControlName="smsconsent" class="example-margin"
                  [checked]="signUpForm.controls['smsconsent'].value === 1" (change)="onSmsConsentChange($event)">
                  <span class="text-444 font-normal text-sm lg:text-lg">
                    I agree to receive free SMS messages from Online Munim.
                  </span>
                </mat-checkbox>
              </div>
            </div>
          </div>

          <div class="flex items-center justify-center mt-4 md:mt-6">
            <button type="submit"
              class="block cursor-pointer px-5 md:px-7 lg:px-10 w-[150px] lg:w-[300px] py-2 lg:py-3.5 text-base md:text-lg lg:text-2xl font-bold text-white bg-c19725 border-2 border-c19725 hover:bg-[#fdffc6] hover:text-c19725 hover:shadow-lg focus:ring-0 focus:outline-none rounded-lg text-center">Submit</button>
          </div>
          <p class="text-[#898989] font-normal text-sm lg:text-lg text-center mt-6">Already registered ?<a
              routerLink="/login" class="underline underline-offset-2 mx-1 font-bold text-c19725">Sign in here.</a></p>
        </form>
      </div>
    </div>
  </div>
</div>
